// LevelLoader loads level data from JSON files and transforms them based on
// schema version.

type RawData = {
	[key: string]: any;
};

export default class LevelLoader {
	public static sharedInstance = new LevelLoader();

	public async load(level: string): Promise<RawData> {
		const levelData = await import(`../levels/${level}.json`);

		if (!levelData) {
			throw new Error(`Invalid level: ${level}`);
		}

		return levelData;
	}
}
